module.exports = __webpack_public_path__ + "static/media/emptyBasket.94855d38.png";